var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useLazyQuery } from '@apollo/client';
// MEMBER_LOCATIONS
var MEMBER_LOCATIONS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query MemberLocations($id: ID!) {\n    member(id: $id) {\n      id\n      locations {\n        id\n        address\n      }\n      address_details {\n        address_1\n        city\n        state\n        zip\n      }\n    }\n  }\n"], ["\n  query MemberLocations($id: ID!) {\n    member(id: $id) {\n      id\n      locations {\n        id\n        address\n      }\n      address_details {\n        address_1\n        city\n        state\n        zip\n      }\n    }\n  }\n"])));
export var useMemberLocationsLazyQuery = function (options) {
    return useLazyQuery(MEMBER_LOCATIONS, options);
};
export default MEMBER_LOCATIONS;
var templateObject_1;
